import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import { Card, CardContent } from '../../../components/ui/Card';
import Icon from '../../../components/AppIcon';

const AssignVendorCodeModal = ({ vendor, isOpen, onClose, onSubmit }) => {
  const [vendorCode, setVendorCode] = useState('');
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async () => {
    setLoading(true);
    try {
      // Strip all whitespace from the vendor code
      const trimmedCode = vendorCode.trim();
      await onSubmit(trimmedCode || null);
      // Reset form on success
      setVendorCode('');
    } catch (error) {
      // Error handling is done in parent component
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setVendorCode('');
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <Card className="w-full max-w-md border border-slate-200 shadow-sm bg-white">
        <CardContent className="p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-xl font-bold text-slate-900">Assign Vendor Code</h3>
            <button
              onClick={handleClose}
              className="text-slate-400 hover:text-slate-600 transition-colors"
              disabled={loading}
            >
              <Icon name="X" size={20} />
            </button>
          </div>
          
          <div className="mb-4">
            <p className="text-sm text-slate-600 mb-2">
              Assigning code to: <strong>{vendor.company_name}</strong>
            </p>
            <p className="text-sm text-slate-600 mb-4">
              Enter a unique vendor code or leave blank to auto-generate.
            </p>
            <input
              type="text"
              value={vendorCode}
              onChange={(e) => setVendorCode(e.target.value)}
              placeholder="e.g. VND0001"
              className="w-full border border-slate-300 rounded-lg px-4 py-2 focus:outline-none focus:border-slate-500 focus:ring-2 focus:ring-slate-200 transition-all text-sm"
              disabled={loading}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !loading) {
                  handleSubmit();
                }
              }}
            />
          </div>
          
          <div className="flex justify-end gap-3">
            <Button
              variant="outline"
              onClick={handleClose}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              variant="default"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? 'Assigning...' : 'Assign'}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AssignVendorCodeModal;